import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AdBanner } from '../../../shared/models/ad-banner.model';
import { BackendResponse } from '../../types/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../config';
import { SnackbarService } from '../utils/snackbar.service';

@Injectable({ providedIn: 'root' })
export class AdBannersService {
  private adBanners: AdBanner[] | null = null;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService
  ) {}

  loadAdBanners(): Observable<AdBanner[]> {
    if (this.adBanners) {
      return new Observable(observer => {
        observer.next(this.adBanners!);
        observer.complete();
      });
    }

    return new Observable<AdBanner[]>(observer => {
      this.getAdBanners().subscribe({
        next: res => {
          this.adBanners = res.data;
          observer.next(this.adBanners);
          observer.complete();
        },
        error: err => {
          console.error('Failed to load ad banners', err);
          observer.error(err);
        },
      });
    });
  }

  getAdBanners(): Observable<BackendResponse<AdBanner[]>> {
    const url = this.configService.endpoints.adBanners.getAdBanners;
    return this.http.get<BackendResponse<AdBanner[]>>(url).pipe(
      catchError(error => {
        if (!error.isHandled) {
          this.snackbarService.error(
            this.translateService.instant(
              'adBanners.error.inAdBannersRetrieving'
            )
          );
        }
        return throwError(() => error);
      })
    );
  }

  saveNewTrackingSession(value: any): Observable<any> {
    const url = `${this.configService.endpoints.adBanners.getAdBanners}/tracking`;
    return this.http.post<BackendResponse<any>>(url, value).pipe(
      map(res => (res['data'] ? res['data'] : [])),
      catchError(error => throwError(() => error))
    );
  }

  updateTrackingSessionField(id: string, value: any): Observable<any> {
    const url = `${this.configService.endpoints.adBanners.getAdBanners}/tracking/${id}`;
    return this.http.put<BackendResponse<any>>(url, value).pipe(
      map(res => (res['data'] ? res['data'] : [])),
      catchError(error => throwError(() => error))
    );
  }
}
